import { z } from "zod";
import { LEFTOVER_MODES, PIX_KEY_TYPES, SETTLEMENT_METHODS, SPLIT_MODES } from "../domain/types.js";
/**
 * O texto padrao do zod e em ingles ("Required", "Expected string..."), e ele
 * aparece na tela: o formulario usa estes mesmos schemas via zodResolver, entao
 * enviar um campo vazio mostrava "Required" embaixo do campo. Como o modulo e
 * importado por todos os schemas, definir o mapa aqui cobre servidor e
 * navegador de uma vez. Mensagem escrita no proprio campo continua vencendo:
 * o mapa so e consultado quando nao existe uma.
 */
z.setErrorMap((issue, ctx) => {
    if (issue.code === z.ZodIssueCode.invalid_type) {
        if (issue.received === "undefined" || issue.received === "null") {
            return { message: "Preencha este campo." };
        }
        return { message: "Valor inválido." };
    }
    return { message: ctx.defaultError };
});
/** Um id sempre e uuid v4 gerado pelo banco. */
export const idSchema = z.string().uuid({ message: "Identificador inválido." });
/** Todo dinheiro trafega em centavos inteiros. R$ 21.474.836,47 e o teto (int4). */
export const centsSchema = z
    .number({ invalid_type_error: "Informe um valor válido." })
    .int({ message: "O valor precisa estar em centavos inteiros." })
    .max(2_147_483_647, { message: "Valor alto demais." });
export const positiveCentsSchema = centsSchema.min(1, { message: "O valor precisa ser maior que zero." });
export const pixKeyTypeSchema = z.enum(PIX_KEY_TYPES);
export const splitModeSchema = z.enum(SPLIT_MODES);
export const leftoverModeSchema = z.enum(LEFTOVER_MODES);
export const settlementMethodSchema = z.enum(SETTLEMENT_METHODS);
export const isoDateSchema = z
    .string()
    .datetime({ offset: true, message: "Data inválida." })
    .or(z.string().regex(/^\d{4}-\d{2}-\d{2}$/, { message: "Data inválida." }));
/** Texto obrigatorio ja sem espaco sobrando nas pontas. */
export const requiredText = (max, label) => z
    .string()
    .trim()
    .min(1, { message: `Preencha o campo ${label}.` })
    .max(max, { message: `O campo ${label} é longo demais.` });
/** Texto opcional: string vazia vira undefined, para nao gravar "" no banco. */
export const optionalText = (max) => z
    .string()
    .trim()
    .max(max, { message: "Texto longo demais." })
    .optional()
    .transform((value) => (value === "" ? undefined : value));
//# sourceMappingURL=common.js.map